import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {ApiFactoryService} from '../shared/services/api-factory.service';
import {AbstractBffApi} from '../models/sharedinterface';
import {ShareddataService} from '../shared/services/shareddata.service';
import {GlobalsService} from '../shared/services/globals.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class RouteguardGuard implements CanActivate {

  isloggedin: boolean;

  bffapi: AbstractBffApi;

  constructor(
    private authservice: AuthenticationService,
    private router: Router,
    private apifactory: ApiFactoryService,
    private shareddata: ShareddataService,
    private globalsservice: GlobalsService
  ) {
    this.bffapi = this.apifactory.createBffApi();
    this.authservice.isloggedin$.subscribe((data) => {
      this.isloggedin = data;
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Mandatory in routeguard to check also localsession independantly of shared variables
    this.authservice.checkLocalSession();

    if (this.isloggedin) {

      // Recheck remote session
      const checkUserQuery = this.bffapi.checkuser();
      checkUserQuery.subscribe((response) => {

          const roles = response.results.roles;
          this.shareddata.setUserroles(roles);

          this.authservice.setLoggedin(true);

          // If tool
          // :languagekey/ext/:toolid/:toolkey
          const pathstructure = next.routeConfig.path;
          switch (pathstructure) {
            case this.globalsservice.getToolPathStructureWithQuery():
            case this.globalsservice.getToolPathStructure():

              this.shareddata.setIspreloading(true);

              // Refresh tool url here
              const toolid = next.paramMap.get('toolid');
              const toolkey = next.paramMap.get('toolkey');
              let params = next.paramMap.get('params');
              // Protect against null params
              if (!params) {
                params = '';
              } // if
              this.shareddata.setCurrentTool({
                toolid: parseInt(toolid),
                toolkeyword: toolkey
              });

              let languagekey = next.paramMap.get('languagekey');
              if (!languagekey) {
                languagekey = this.globalsservice.getDefaultLanguagekey();
              } // if
              this.shareddata.setCurrentlanguage(this.globalsservice.getLanguage(languagekey));

              // console.log('click on tool');
              // console.log('get tool login');

              const getToolLogin = this.bffapi.gettoollogin(parseInt(toolid), toolkey, languagekey, params);
              getToolLogin.subscribe((response) => {
                const toolurltoken = response.results.toolurltoken;
                const words = CryptoJS.enc.Base64.parse(toolurltoken);
                const url = CryptoJS.enc.Utf8.stringify(words);

                // console.log('at routeguardguard, change iframe url');

                // Important. settting preloader to false is at toolview component.

                console.log("change iframe url from routeguard");
                this.shareddata.changeiframeURL(url);

              }, error => {
                this.shareddata.setIspreloading(false);
              });

              break;

            case this.globalsservice.getHelpPathStructure():
              const languagekey2 = next.paramMap.get('languagekey');
              const query2 = this.bffapi.gethelp(languagekey2);
              query2.subscribe((response) => {
                this.shareddata.setSharedhelpdata(response.results);
              });

              break;

            case 'admin':

              break;

          } // switch


        },
        error => {
          this.authservice.setLoggedin(false);
          this.router.navigate(['']);
        });
    } else {
      this.authservice.setLoggedin(false);
      this.router.navigate(['']);
    } // if

    return true;

  }

}
